export const cameraView02BowSpritImageOptions = {
  legacy: true,
  prefix: 'X4_9_Exterior',
  angle: 'Camera View 02 - Bow sprit',
  staticOptions: {
    HullTreatment: 1,
    TeakOnCoachroof: 1,
    TeakOnBathingPlatform: 1,
    SprayHood: 1,
    Wheel: 1,
    Boom: 1,
    MastAndBoom: 1
  },
  mattes: []
}



// WEBPACK FOOTER //
// ./src/X49/views/CameraView02BowSprit.js